import AnalyticsService from '@root/core/src/services/analytics-service';
import EppoClientService from '@root/core/src/services/eppo-client-service';
import { RootIdService } from '@root/attribution/src/services/root-id-service';

const FLAG_KEY = 'cookie-banner-ab-test';
const DEFAULT_VARIANT = 'control';
// Direct and HostedX share this flag, so the surface has to be an explicit attribute:
// Eppo evaluates locally and has no notion of which property asked.
const SURFACE = 'legacy_web';

// Owned here, not by the caller: a caller that gave up on a pending evaluate() could not
// stop it recording an assignment for a visitor whose banner stayed hidden.
const EPPO_RESOLUTION_BUDGET_MS = 1200;

function settledOrTimedOut(promise, ms) {
  const timeout = new Promise((resolve) => { setTimeout(resolve, ms); });

  // catch() so a rejected init resolves the race instead of propagating.
  return Promise.race([promise.catch(() => {}), timeout]);
}

// Pre-warm so the config fetch runs in parallel with Osano's startup, not inside the
// hide-then-show window. Gated because this bundle ships to apps that never bucket.
if (document.querySelector('script[data-cookie-banner-ab-test="true"]')) {
  EppoClientService.initialize();
}

window.__cookieBannerEppo = {
  async evaluate(market) {
    const startedAt = Date.now();

    try {
      const rootId = RootIdService.read();

      if (!rootId) {
        return {
          variant: DEFAULT_VARIANT,
          timedOut: false,
        };
      }

      await settledOrTimedOut(EppoClientService.initialize(), EPPO_RESOLUTION_BUDGET_MS);

      // Load-bearing: Promise.race does not cancel the loser, so without this gate a
      // slow init would still reach getStringAssignment and record a phantom assignment.
      if (Date.now() - startedAt >= EPPO_RESOLUTION_BUDGET_MS) {
        return {
          variant: DEFAULT_VARIANT,
          timedOut: true,
        };
      }

      const variant = EppoClientService.getStringAssignment(
        FLAG_KEY,
        rootId,
        {
          surface: SURFACE,
          market,
          resolutionMs: Date.now() - startedAt,
        },
        DEFAULT_VARIANT,
      );

      return {
        variant,
        timedOut: false,
      };
    } catch (error) {
      return {
        variant: DEFAULT_VARIANT,
        timedOut: false,
      };
    }
  },

  reportOutcome({
    variant, budgetPath, ms, market,
  }) {
    AnalyticsService.trackEvent('COOKIE_BANNER_AB_TEST', 'DECIDED', {
      variant,
      budgetPath,
      elapsedMs: ms,
      market,
      configUsable: String(EppoClientService.isConfigUsable()),
    });
  },
};
